class Index {
    rc;
    _parent;
    constructor(_parent) {
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/everyone`;
    }
    /**
     * Returns information about "Everyone" chat (a company level chat which includes all employees).
     * HTTP Method: get
     * Endpoint: /team-messaging/v1/everyone
     * Rate Limit Group: Light
     * App Permission: TeamMessaging
     */
    async get(restRequestConfig) {
        const r = await this.rc.get(this.path(), undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Updates "Everyone" chat information.
     * HTTP Method: patch
     * Endpoint: /team-messaging/v1/everyone
     * Rate Limit Group: Medium
     * App Permission: TeamMessaging
     */
    async patch(updateEveryoneTeamRequest, restRequestConfig) {
        const r = await this.rc.patch(this.path(), updateEveryoneTeamRequest, undefined, restRequestConfig);
        return r.data;
    }
}
export default Index;
